import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogle = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16 8.016A8.522 8.522 0 008.016 16h-.032A8.521 8.521 0 000 8.016v-.032A8.521 8.521 0 007.984 0h.032A8.522 8.522 0 0016 7.984v.032z",
		fill: "url(#prefix__paint0_radial_980_20147)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("radialGradient", {
		id: "prefix__paint0_radial_980_20147",
		cx: 0,
		cy: 0,
		r: 1,
		gradientUnits: "userSpaceOnUse",
		gradientTransform: "matrix(16.1326 5.4553 -43.70045 129.2322 1.588 6.503)",
		children: [
			/* @__PURE__ */ _jsx("stop", {
				offset: .067,
				stopColor: "#9168C0"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .343,
				stopColor: "#5684D1"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .672,
				stopColor: "#1BA1E3"
			})
		]
	}) })]
});
export default SvgGoogle;
